// extracted by mini-css-extract-plugin
export default {"container":"CompletedWorksPage_container__NmaSf"};